import { RiskLevel } from "@/model/RiskLevel";
import SheffieldLogo from "@/assets/regions/likewise-logo_red.svg";
const Increasing = {
    rawCopy: "For Increasing Risk scores we recommend you cut down on your alcohol drinking, " +
        "click here for more information about your <u>local&nbsp;alcohol&nbsp;service.</u>",
    logoLink: "https://likewisesheffield.org.uk/"
};
const Higher = {
    rawCopy: "For <strong>Higher Risk scores we recommend you cut down on your alcohol drinking, " +
        "click here for more information about your <u>local&nbsp;alcohol&nbsp;service.</u>",
    logoLink: "https://likewisesheffield.org.uk/"
};
const High = {
    rawCopy: "For <strong>High Risk/Possible Dependence</strong> scores we strongly recommend seeking " +
        "advice from a GP or <u>local&nbsp;alcohol&nbsp;service.</u>",
    logoLink: "https://likewisesheffield.org.uk/"
};
const SheffieldLower = {
    rawCopy: "For alcohol advice and support in Sheffield, contact Likewise on 0114 308 7000",
    logoLink: "https://likewisesheffield.org.uk/"
};
export default {
    name: "Sheffield",
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: SheffieldLower,
        [RiskLevel.Lower]: SheffieldLower,
        [RiskLevel.Increasing]: Increasing,
        [RiskLevel.Higher]: Higher,
        [RiskLevel.High]: High
    },
    logo: {
        file: SheffieldLogo,
        width: 347,
        height: 230
    },
    clinics: [
        {
            name: "Likewise",
            tagline: "Likewise is the alcohol and drug service for adults in Sheffield.",
            description: "Contact ${name}",
            location: { lat: 53.3873999, lng: -1.4779029, },
            address: "Portland House, 243 Shalesmoor, Moorfields, Sheffield S3 8UG",
            times: [
                {
                    title: "Opening times:",
                    info: "Closed bank holidays",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1900 }],
                        friday: [{ start: 900, end: 1630 }],
                        saturday: [{ start: 900, end: 1200 }]
                    }
                }
            ],
            isPrimaryProvider: true,
            phone: ["0114 308 7000"],
            email: "info@likewisesheffield.org.uk",
        },
    ]
};
//# sourceMappingURL=Sheffield.js.map